module.exports = __webpack_public_path__ + "img/1_1-macerie-0.c30de300.png";